var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":"/tablePrint"}},[_vm._v("表格打印")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }